/** @format */
import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Table,
  Button,
  Modal,
  Input,
  Tag,
  Row,
  Col,
  message,
} from "antd";
import Cookies from "universal-cookie";
import { readCookie } from "../../../cookie";

const cookies = new Cookies();
const currentToken = cookies.get("access_token");
let userData = JSON.parse(readCookie('userData'))

const Factories = () => {
  const [factories, setFactories] = useState([]);
  const [loading, setLoading] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);
  const [form, setForm] = useState({
  factory_id: "",
  name: "",
  state: "",
  district: "",
});


  const BASE_URL = process.env.REACT_APP_API_APP_FIELD_URL;

  /* ---------------- Fetch ---------------- */

  const fetchFactories = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${BASE_URL}/nector/web/factories`, {
        headers: {
          "Content-Type": "application/json",
          source: "humblebee_admin",
          authorization: `Bearer ${currentToken}`,
        },
      });
      setFactories(res.data || []);
    } catch {
      message.error("Failed to load factories");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFactories();
  }, []);

  /* ---------------- Create ---------------- */

  const openAdd = () => {
    setForm({
  factory_id: "",
  name: "",
  state: "",
  district: "",
    });

    setModalOpen(true);
  };

  const submit = async () => {
    if (!form.factory_id || !form.name || !form.state) {
      return message.warning("Factory ID, Name, and State are required");
    }

    try {
      await axios.post(
        `${BASE_URL}/nector/web/factories`,
        {
          factory_id: form.factory_id,
          name: form.name,
          state: form.state,
          district: form.district || null,
        },
        {
          headers: {
            "Content-Type": "application/json",
            source: "humblebee_admin",
            authorization: `Bearer ${currentToken}`,
          },
        }
      );

      message.success("Factory created");
      setModalOpen(false);
      fetchFactories();
    } catch {
      message.error("Failed to create factory");
    }
  };

  /* ---------------- Disable ---------------- */

  const disableFactory = (row) => {
    Modal.confirm({
      title: "Disable Factory?",
      content:
        "This factory will no longer be usable for creating new batches.",
      okText: "Disable",
      okType: "danger",
      onOk: async () => {
        try {
          await axios.patch(
            `${BASE_URL}/nector/web/factories/${row.factory_id}/disable`,
            {},
            {
        headers: {
          'Content-Type': 'application/json',
          source: 'humblebee_admin',
          authorization: `Bearer ${currentToken}`,
        },
      }
          );
          message.success("Factory disabled");
          fetchFactories();
        } catch {
          message.error("Failed to disable factory");
        }
      },
    });
  };

  /* ---------------- Table ---------------- */

const columns = [
  {
    title: "Factory ID",
    dataIndex: "factory_id",
  },
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "State",
    dataIndex: "state",
  },
  {
    title: "District",
    dataIndex: "district",
    render: (v) => v || "-",
  },
  {
    title: "Status",
    dataIndex: "is_active",
    render: (isActive) =>
      isActive ? (
        <Tag color="green">Active</Tag>
      ) : (
        <Tag color="red">Disabled</Tag>
      ),
  },
  {
    title: "Actions",
    render: (_, row) =>
      row.is_active && (
        <Button danger size="small" onClick={() => disableFactory(row)}>
          Disable
        </Button>
      ),
  },
];

  /* ---------------- UI ---------------- */

  return (
    <div style={{ padding: 24,marginLeft:250}}>
      <Row  justify="space-between" align="middle">
        <Col>
          <h2>Factories</h2>
        </Col>
        <Col>
          <button className="btn add-new-scheme-btn" onClick={openAdd}>
            Add Factory
          </button>
        </Col>
      </Row>
      <Table
        style={{ marginTop: 16 }}
        rowKey="factory_id"
        columns={columns}
        dataSource={factories}
        loading={loading}
      />

      {/* ---------------- Modal ---------------- */}

      <Modal
        title="Add Factory"
        visible={modalOpen}
        onCancel={() => setModalOpen(false)}
        onOk={submit}
        okText="Create"
        okButtonProps={{
          className:"btn add-new-scheme-btn"
        }}
      >
        <Row gutter={16}>
          <Col span={24}>
            <label>Factory ID *</label>
            <Input
              placeholder="e.g. VNS"
              value={form.factory_id}
              onChange={(e) =>
                setForm({ ...form, factory_id: e.target.value })
              }
            />
          </Col>

          <Col span={24} style={{ marginTop: 12 }}>
            <label>Factory Name *</label>
            <Input
              placeholder="Varanasi Factory"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
            />
          </Col>

          <Col span={24} style={{ marginTop: 12 }}>
            <label>State *</label>
            <Input
              placeholder="e.g. Uttar Pradesh"
              value={form.state}
              onChange={(e) =>
                setForm({ ...form, state: e.target.value })
              }
            />
          </Col>

          <Col span={24} style={{ marginTop: 12 }}>
            <label>District</label>
            <Input
              placeholder="e.g. Varanasi"
              value={form.district}
              onChange={(e) =>
                setForm({ ...form, district: e.target.value })
              }
            />
        </Col>
        </Row>
      </Modal>
    </div>
  );
};

export default Factories;
